import { createAsyncThunk } from "@reduxjs/toolkit";

import { isErrorResult, makeApiRequest, ENDPOINTS_PROOF } from "services";

import { ErrorResult } from "services/types";
import { CheckLiskProofPayload } from "./types";
import { TokenProofResponse } from "../solana-proof/types";

export const checkLiskProof = createAsyncThunk<TokenProofResponse, CheckLiskProofPayload, { rejectValue: ErrorResult }>(
  "zkp/check-lisk-proof",
  async (data, { rejectWithValue }) => {
    const result = await makeApiRequest<TokenProofResponse>({
      method: "POST",
      url: ENDPOINTS_PROOF.checkLiskProof,
      data,
    });

    if (isErrorResult(result)) {
      return rejectWithValue(result);
    }

    return result;
  },
);
